import React, { useState, useEffect} from "react";
import { LoyaltyTwoTone } from "@material-ui/icons";
import axios from "axios";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import SalesOrderInfoTable from "./SalesOrderInfoTable";
import SalesAddItem from "./SalesAddItem";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {  useParams, useHistory } from "react-router-dom";
import { format } from "date-fns";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import MUIDataTable from "mui-datatables";
//number format plugin
import numeral from "numeral";

import PurchaseOrderInfoTable from "../../Purchases/PurchaseOrderInfoTable";
import PurchaseAddItem from "../../Purchases/PurchaseAddItem";
import PurchaseEditShipping from "../../Purchases/PurchaseEditShipping";
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { NavLink } from "react-router-dom";
import Preloader from "../../../components/Preloader/Preloader";

import Slide from '@material-ui/core/Slide';
import SalesModal from "../SalesModal";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	paper: {
		background: "#339933",
		width:"100%",
		height:"50px",
	    },
	    formlabelpayment: {
		color:"white",
		margin:"10px",
		float:"right"
	    },
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
});

const SalesOrderInformation = () => {
	const istype = 'notbranch'; // hardcode for now
	const { shippingId, warehouseId, idNo, trantype } = useParams();
	const [soDetails, setSoDetails] = useState(null);

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	const [items, setItems] = useState([]); //data to display in SO table
	const [supplierItem, setSupplierItem] = useState([]); 
	const [showModal, setShowModal] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(true); // for saving of items, shipping and notes
	const [btnDisabled2, setBtnDisabled2] = useState(true); //for saving of sales order
	const [advancepayment, setAdvancepayment] = useState("no");

    //Message Box
    const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
    //Message Box EOF

	//salesOrderPayment
	const [showPaymentPage, setShowPaymentPage] = useState(false);
	//Payment Type dropdown data
	const [paymentType, setPaymentType] = useState([]);
	const [paymentId, setPaymentId] = useState(0);
	const [paymentAmount, setPaymentAmount] = useState(0);
	const [paymentReference, setPaymentReference] = useState('');
	const [grandTotal, setGrandTotal] = useState(0);
	const [maxQty,setMaxQty] =useState(0);

	const [openModal, setOpenModal] = useState(false);

	///mutiple payment
	const [TABLE_DATA, setSelectedPaymentTable] = useState([]);
	const [selectedPayment, setSelectedPayment] = useState({});
	const [computedPayment, setComputedPayment] = useState({});
	const [defaultPayment, setDefaultPayment] = useState({
	  id: 0,
	  description: "Select Payment",
	  status: 0,
	  clearing: "none",
	});
	const [clearPayment, setClearPayment] = useState({
	  id: 0,
	  description: "Select Payment",
	  status: 0,
	  clearing: "none",
	});
	
	// combine all payment details neeeded before saving final SO
	// {
    //     "payment_id":paymentId,
    //     "payment_amount": parseFloat(paymentAmount),
    //     "payment_ref":paymentReference
    // }
	let history = useHistory();
	const classes = useStyles();
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => { //
		data();
	}, []);

	
	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.item_id);
		if(found){
			console.log('hehe',item);
			// //if item is existing in itemArray, add the qty instead
			// let newItems = items.map((it)=> {
			// 	if(it.item_id === item.item_id){ //add
			// 		it.qty += item.qty;
			//   	}
			//   return it;
			// });
			// setItems(newItems);
			let newItems = items.map((it) => {
				if (it.item_id === item.item_id) {
				  const newQty = it.qty + item.qty;
				  if (item.maxQty !== undefined && newQty > item.maxQty) {
					setShowMsgBox(true);
					setMsg("Quantity exceeds available stock.");
					setMsgType("error");
					setTimeout(() => {
					  setShowMsgBox(false);
					}, 2500);
				    return it; // don't update qty
				  }
				  it.qty = newQty;
				}
				return it;
			      });
			      setItems(newItems);
			
		}else{
			console.log('2',item);
			//add new unique item to array
			if (item.maxQty !== undefined && item.qty > item.maxQty) {
				setShowMsgBox(true);
				setMsg("Quantity exceeds available stock.");
				setMsgType("error");
				setTimeout(() => {
				  setShowMsgBox(false);
				}, 2500);
				return;
			      }
			setItems([...items, 
				{
				item_id: item.item_id, 
				qty: item.qty,
				price: item.price, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		//console.log(item_id);
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty))
		setPoTotal(po_total);

		if(items.length > 0 && advancepayment) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items,advancepayment]);

	useEffect(() => {
		if(paymentId && paymentAmount==grandTotal && paymentReference!='') {
			setBtnDisabled2(false); // re-enable
		}else{
			setBtnDisabled2(true); // re-enable	
		}
	}, [paymentId,paymentAmount,grandTotal,paymentReference]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/sales_order_form', {
			params:{
				jc_u_idno: get_cookies('branchidno'),  //branchIdNo
				trandate: format(new Date(), "yyyy-MM-dd"), 
				shipping: shippingId, 
				warehouse: warehouseId, 
				idno: idNo, 
				trantype: trantype, 
				curcode: get_cookies('curcode'), 
			}
		}).then((res)=>{
			setSoDetails(res.data.data);
			setSupplierItem(res.data.data.items);
		}).catch((error)=>{
			//console.log(JSON.stringify(error));
			setShowMsgBox(true);
			// setMsg("Something went wrong: "+error.message);
			setMsg("ID No not found");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});


	}
	const selectType = [
		{ title: "No Advance Payment", value:'no' },
		{ title: "With Advance Payment/Sales Return", value:'yes'  }
	]
	const defaultProps = {
		options: selectType,
		getOptionLabel: (option) => option.title,
	};
	const checkPaymentProps = {
		options: paymentType,
		getOptionLabel: (option) => option.description,
	};
	const modalMessage = "Please wait...";
	// totalamount:
	// notes:
	// advancepayment:
	// pricecat:
	// idno:
	// shippingcharge:
	// trantype:
	// curcode:
	// istype:
	// item_array:

	const proceed_so = async () => {
		//setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(items));
		formData.append("totalamount", Number(shipTotal)+Number(poTotal));
		formData.append("advancepayment", advancepayment);
		formData.append("pricecat", soDetails.pricecat);
		formData.append("idno", idNo);
		formData.append("shippingcharge", shipTotal);
		formData.append("trantype", trantype);

		formData.append("curcode",get_cookies('curcode')); //hardcoded for now
		formData.append("istype", "notbranch"); //hardcoded for now
		if(advancepayment === 'no'){
			//show 3rd ui, sales order payment
			await axios.post(process.env.REACT_APP_API_URL+'proceed_so', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
			}).then((res)=>{
				// setSoDetails(res.data.data);
				// setSupplierItem(res.data.data.items);
				setPaymentType(res.data.data.payment_options);
				setGrandTotal(res.data.data.grandtotal);
				setShowPaymentPage(true); // show salesORderPayment form, hides current layouts
				console.log(res.data.data.payment_options);
			}).catch((error)=>{
			//console.log(error.message);
			});
		}else{
			formData.append("jc_u_idno", get_cookies('branchidno'));
			formData.append("jc_uname", get_cookies('username'));
			formData.append("trandate", format(new Date(), "yyyy-MM-dd"));
			formData.append("shipping", shippingId);
			formData.append("notes", notes);
			formData.append("warehouse", warehouseId);
			setBtnDisabled(true);
			setShowModal(true); //show loading/please wait modal
			//write to db, usual saving etc
			await axios.post(process.env.REACT_APP_API_URL+'proceed_so', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function (res) {
					setShowModal(false); //hide loading/please wait modal
					setShowMsgBox(true);
					setMsg("Added new SO");
					setMsgType("success");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); // re-enable
						history.push('/sales/sales-order');
					}, 2000)
				  }).catch(function (error) {
					setShowModal(false); //hide loading/please wait modal 
					setShowMsgBox(true);
					setMsg("Something went wrong: "+error);
					setMsgType("warning");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); // re-enable
					}, 2500)
				  });
		}
	}

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const save_final_so = async () => {
		setBtnDisabled2(true); // disable button to avoid multiple saves
		setShowModal(true);
		const formData = new FormData();
		let payment_array = [
			{
				payment_id:paymentId,
				payment_amount:paymentAmount,
                payment_ref:paymentReference
			}
		];
		formData.append("payment_array", JSON.stringify(TABLE_DATA));
		formData.append("item_array", JSON.stringify(items));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("jc_uname", get_cookies('username'));
		formData.append("curcode", get_cookies('curcode'));
		formData.append("idno", idNo);
		formData.append("warehouse", warehouseId);
		formData.append("pricecat", soDetails.pricecat);
		formData.append("trandate", format(new Date(), "yyyy-MM-dd"));
		formData.append("shipping", shippingId);
		formData.append("shippingcharge", shipTotal);
		formData.append("notes", notes);
		formData.append("trantype", trantype);
		formData.append("classificationtype", soDetails.class_type);
		//formData.append("jc_sopreorder", ""); //not pre-orders;
			//show 3rd ui, sales order payment
			await axios.post(process.env.REACT_APP_API_URL+'save_final_so', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Added new SO");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled2(false); // re-enable
					history.push('/sales/sales-order');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled2(false); // re-enable
				}, 2500)
	  		});
	}
	const onSelectPayment = () => {
		let newData = [...TABLE_DATA];
	    
		const neededKeys = ["payment_amount", "payment_id"];
	    
		// console.log('2',neededKeys)
		// console.log('2',neededKeys)
		if (neededKeys.every((key) => Object.keys(selectedPayment).includes(key))) {
		  let tempObj;
		  if(selectedPayment.paymentname == "Cash"){
		     tempObj = {
		      payment_id: selectedPayment.payment_id,
		      paymentname: selectedPayment.paymentname,
		      payment_amount: selectedPayment.payment_amount,
		      payment_ref: selectedPayment.payment_ref,
		    };
		  }else{
		     tempObj = {
		      payment_id: selectedPayment.payment_id,
		      paymentname: selectedPayment.paymentname,
		      payment_amount: selectedPayment.payment_amount,
		      payment_ref: selectedPayment.payment_ref,
		    };
		  }
		    if (
		      selectedPayment.payment_id == "" ||
		      selectedPayment.payment_amount == "" ||
		      selectedPayment.payment_amount == 0 ||
		      selectedPayment.payment_ref == "" ||
		      selectedPayment.payment_ref == null ||
		      selectedPayment.payment_id == null
		    ) {
		      setShowMsgBox(true);
		      setMsg("Please complete all required fields");
		      setMsgType("warning");
		      setTimeout(() => {
			setShowMsgBox(false);
		      }, 3000);
		    } else {
			let amttoadd = Number(computedPayment.total_payment) + Number(selectedPayment.payment_amount);
			if(Number(amttoadd) > (Number(computedPayment.topay_amount))){
			setShowMsgBox(true);
			setMsg("Payment is greater than to the amount to be settle");
			setMsgType("warning");
			setTimeout(() => {
			  setShowMsgBox(false);
			}, 3000);
		      } else {
			addOrUpdate(newData, tempObj);
			clear_fields();
		      }
		    }
		  
		} else {
		  setShowMsgBox(true);
		  setMsg("Please complete all required fields");
		  setMsgType("warning");
		  setTimeout(() => {
		    setShowMsgBox(false);
		  }, 3000);
		}
	      };
	      const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedPaymentTable([...newData]);
	      };
	    
	      const TABLE_COLUMNS = [
		{
		  name: "payment_id",
		  label: "ID",
		},
		{
		  name: "paymentname",
		  label: "Payment Type",
		},
		{
		  name: "payment_amount",
		  label: "Amount",
		},
		{
		  name: "payment_ref",
		  label: "Reference",
		},   {
			      name: "action",
			      label: "Action",
			      options: {
				customBodyRender: (value, tableMeta, updateValue) => {
				  const rowIndex = tableMeta.rowIndex;
				  return (
				    <Button
				      variant="contained"
				      color="secondary"
				      onClick={() => updateSelectedPayment(rowIndex)}
				    >
				      Delete
				    </Button>
			
				  );
				},
			      },
			    },
	      ];
	    
	      const TABLE_OPTION = {
		selectableRowsHideCheckboxes: true,
		// selectableRowsOnClick: true,
		print: false,
		filter: false,
		download: false,
		viewColumns: false,
		// onRowsDelete: (data) => {
		//   updateSelectedPayment(data.data[0].dataIndex);
		// },
	      };
	      useEffect(() => {
		const newData = { ...computedPayment };
	    
		  newData["topay_amount"] = grandTotal;
		newData["shipping_amount"] = shipTotal;
		newData["total_balance"] =
		  parseFloat(grandTotal) 
		setComputedPayment({ ...newData });
	      }, [grandTotal]);
	      useEffect(() => {
		if(computedPayment.total_balance >0){
	    setBtnDisabled2(true);
		}else{
		  setBtnDisabled2(false);
		}
	    
	      }, [computedPayment.total_balance]);
	    
	      const computePayment = () => {
		let total_payment = 0;
		for (let index = 0; index < TABLE_DATA.length; index++) {
		  total_payment =
		  parseFloat(total_payment) + Number(parseFloat(TABLE_DATA[index].payment_amount));
		}
		const newData = { ...computedPayment };
		const total_balance =
		  parseFloat(computedPayment.topay_amount) -
		  parseFloat(total_payment);
		newData["total_payment"] = total_payment;
		newData["total_balance"] = total_balance;
		setComputedPayment({ ...newData });
	      };
	    
	    
	      const updateSelectedPayment = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	      };
	      const clear_fields = () => {
		const newData = { ...selectedPayment };
		newData["payment_id"] = "";
		newData["paymentname"] = "";
		newData["payment_amount"] = "";
		newData["payment_ref"] = "";
		setSelectedPayment({ ...newData });
		setDefaultPayment(clearPayment);
	      };
	      const addOrUpdate = (array, item) => {
		const i = array.findIndex((_item) => _item.payment_id === item.payment_id);
		if (i > -1) {
		  array[i].payment_amount =
		    parseFloat(array[i].payment_amount) + parseFloat(item.payment_amount);
		  array[i].payment_ref = item.payment_ref;
		  computePayment();
		} else {
		  array.push(item);
		  setSelectedPaymentTable([...array]);
		}
	      };
	      const numericOnly = (event) => {
		var regex = /^\d*\.?\d*$/;
		let x = "";
		if (regex.test(event.target.value)) {
		  x = event.target.value;
		} else {
		  x = "";
		}
		const y = x.replaceAll("-", "");
		const newData = { ...selectedPayment };
		newData[event.target.name] = y;
		setSelectedPayment({ ...newData });
	      };
	      const onInputChange = (event) => {
		if (!event.target.value.trim().length) {
		  // only white-spaces
		  const newData = { ...selectedPayment };
		  newData[event.target.name] = "";
		  setSelectedPayment({ ...newData });
		} else {
		  const newData = { ...selectedPayment };
		  newData[event.target.name] = event.target.value;
		  setSelectedPayment({ ...newData });
		}
	      };
	      useEffect(() => {
		computePayment();
	      }, [TABLE_DATA]);

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/sales-order"}><h4 style={{color:"#339933"}}>Sales Order</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4 className="header-title">Sales Order Information</h4>
			</div>
			{!showPaymentPage ? (
			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				{supplierItem && soDetails ? (				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Sales Order Information
								</div>
								<div className={classes.title}>
									{soDetails.name || ''}
								</div>
							</Grid>
							{/* <Grid
								item
								xs={4}
								className={classes.buttonContainer}> */}
								<Grid item xs={12} lg={4}>
									{/* <Autocomplete
											{...defaultProps}
											id="auto-complete"
											autoComplete
											includeInputInList
											className={classes.autoComplete}
											style={{marginTop:"2px", marginBottom:"1em"}}
											renderInput={(params) => (
												<TextField
													{...params}
													label="Advance Payment..."
													margin="normal"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													console.log(newValue.title);
													setAdvancepayment(newValue.value);
												}else{
													setAdvancepayment(null);
												}
											}}
									/> */}
								</Grid>
								<Grid item xs={12} lg={8}>
									<Grid container spacing={3} style={{justifyContent: "flex-end"}}>
										{soDetails.shipping == "Pick Up"?null:	<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>}
										
											<SalesAddItem addItem={addItem} supplierItem={supplierItem} setMaxQty={setMaxQty}/>
											{/* <div style={{marginRight: "1em"}}></div> */}
										{/* <div style={{marginRight: "0.5em"}}></div> */}
									</Grid>
								</Grid>	
							</Grid>

					</div>
					<CardContent>
						<LoadingModal showModal={showModal}/>
						<Grid container spacing={1}>
							<Grid item xs={12} lg={6} xl={6}>
								<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										ID No:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.idno || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Date:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.date || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Shipping:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.shipping || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Contact No:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.contact_no || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Address:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.address || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Transaction Type:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.trantype || ''}
									</Grid>
								</Grid>
								</div>	
							</Grid>
							<Grid item xs={12} lg={6} xl={6}>
								<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										JC Wallet:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.jcwallet || ''}
									</Grid>
								</Grid>
								</div>
							</Grid>
						</Grid>
						{/* <SalesOrderInfoTable /> */}
						<SalesOrderInfoTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}		
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(Number(shipTotal)+Number(poTotal)).format('0,0.00')}
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>) : (<Preloader />)}
				<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button> */}
					<ColorButton disabled={btnDisabled} onClick={proceed_so} variant="contained" color="primary" classes={{
   		root: classes.root, 
        disabled: classes.disabled}}>
						Proceed
					</ColorButton>
				</div>
		</div>) : (<></>)}


{/* Sales Order Payment Page */}
{showPaymentPage ? (
        <Slide direction="up" in={showPaymentPage} mountOnEnter unmountOnExit>
          <div className="page-container">
            <SalesModal open={openModal} overLayMsg={modalMessage} />
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />
            <Card className={classes.card}>
              <div className={classes.cardHeader}>
                <Grid
                  container
                  spacing={0}
                  style={{ justifyContent: "flex-end" }}
                >
                  <Grid item xs={8}>
                    <div className={classes.subTitle}>Sales Order</div>
                    <div className={classes.title}>Sales Order</div>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                  <Grid item xs={2} className={classes.buttonContainer}></Grid>
                  <Grid container spacing={2}   style={{ justifyContent: "space-between" }}>
                    <Grid
                      item
                      xs="12"
                      lg="4"
                      xl="3"
                      style={{ marginTop: "1.7em" }}
                    >
                      <form noValidate autoComplete="off">
                        {/* <TextField
                          id="outlined-required"
                          label="Amount To Pay"
                          variant="outlined"
                          fullWidth={true}
                          className={classes.field}
                          value={numeral(grandTotal).format("0,0.00")} //to avoid label overlapping bug
                          InputProps={{
                            readOnly: true,
                          }}
                        /> */}
                        <Autocomplete
                          {...checkPaymentProps}
                          id="auto-complete"
			  value={defaultPayment}
                          autoComplete
                          includeInputInList
                          className={classes.autoComplete}
                          renderInput={(params) => (
                            // <TextField
                            //   {...params}
                            //   label="Payment Type"
                            //   margin="normal"
                            //   variant="outlined"
                            // />
                            <TextField
                            {...params}
                            margin="normal"
                            label="Payment Type"
                            variant="outlined"
                            required="true"
                          />
                          )}
                          // onChange={(event, newValue) => {
                          //   if (!newValue == "" || !newValue == null) {
                          //     // console.log(newValue);
                          //     setpayment_id(newValue.id);
                          //   } else {
                          //     setpayment_id(null);
                          //   }
                          // }}
                          onChange={(event, newValue) => {
                            if (!newValue == "" || !newValue == null) {
                              setDefaultPayment(newValue);
                              const newData = { ...selectedPayment };
                              newData["payment_id"] = JSON.stringify(
                                newValue.id,
                                null,
                                " "
                              );
                              newData["paymentname"] = newValue.description;
                              setSelectedPayment({ ...newData });
                            }
                          }}
                        />
                        <TextField
                           name="payment_amount"
                          style={{ marginTop: "12px" }}
                          id="outlined-required"
                          label="Amount"
                          variant="outlined"
                          type="number"
                          fullWidth={true}
                          className={classes.field}
                          // value={paymentAmount} //to avoid label overlapping bug
                          value={selectedPayment.payment_amount}
                          InputProps={{ inputProps: { min: 0 } }}
                          onKeyPress={(e) => {
                            if (e.key == "-") {
                              e.preventDefault();
                            }
                          }}
                          onChange={numericOnly}
                          // onChange={(e) => {
                          //   setPaymentAmount(e.target.value);
                          // }}
                          // onBlur={(e) => {
                          //   if (parseFloat(e.target.value) > 0) {
                          //     setPaymentAmount(e.target.value);
                          //   } else {
                          //     setPaymentAmount(0);
                          //   }
                          // }}
                        />
                        <TextField
                            name="payment_ref"
                          style={{ marginTop: "12px" }}
                          id="outlined-required"
                          label="Reference"
                          variant="outlined"
                          fullWidth={true}
                          className={classes.field}
                          // value={paymentReference} //to avoid label overlapping bug
                          value={selectedPayment.payment_ref}
                          // onChange={(e) => {
                          //   setPaymentReference(e.target.value);
                          // }}
                          onChange={onInputChange}
                        />
                      </form>
                    </Grid>
                    <Grid item xs={4}>
                    <h4 className={classes.title}>Sales Order Summary</h4>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Amount To Pay:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.topay_amount).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box textAlign="right" className={classes.formlabelpayment} >
                                                     <Typography style={{padding:'1px',paddingRight:'3px'}}>Total Amount To Pay:</Typography>
                                                    </Box>  
                                                    <Box textAlign="right" className={classes.formlabelpayment} fontWeight="fontWeightBold">
                                                    <Typography  style={{paddingRight:'4px'}}>{numeral(computedPayment.topay_amount).format('0,0.00')}</Typography>
                                                    </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Payment:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.total_payment).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Total Payment:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.total_payment).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          style={{
                            padding: "10px",
                          }}
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Shipping:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(
                                  computedPayment.shipping_amount
                                ).format("0,0.00")}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Shipping:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.shipping_amount).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          style={{
                            padding: "10px",
                          }}
                          variant="outlined"
                          className={classes.paper}
                        >
                          <Grid
                            spacing={1}
                            justifyContent="space-between"
                            container
                          >
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                Total Balance:
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography style={{ color: "white" }}>
                                {numeral(computedPayment.total_balance).format(
                                  "0,0.00"
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                          {/* <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                          >
                            <Typography
                              style={{ padding: "1px", paddingRight: "3px" }}
                            >
                              Total Balance:
                            </Typography>
                          </Box>
                          <Box
                            textAlign="right"
                            className={classes.formlabelpayment}
                            fontWeight="fontWeightBold"
                          >
                            <Typography style={{ paddingRight: "4px" }}>
                              {numeral(computedPayment.total_balance).format(
                                "0,0.00"
                              )}
                            </Typography>
                          </Box> */}
                        </Paper>
                      </Grid>
                    </Grid>
              </Grid>
                                   <Grid xs={12} style={{marginBottom:15}}>
                        <div className={classes.button}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={onSelectPayment}
                            className={classes.buttonMarginRigh}
                          >
                            Add Payment
                          </Button>
                        </div>
                      </Grid>
                      
                  </Grid>
                  <Grid item xs={12}>
                        <MUIDataTable
                          title={
                            <div>
                              <div className="table-title">Payment Details</div>
                            </div>
                          }
                          id="table-grid"
                          data={TABLE_DATA}
                          columns={TABLE_COLUMNS}
                          options={TABLE_OPTION}
                        />
                      </Grid>
                </Grid>
              </div>
            </Card>
            <div className={classes.buttonContainer}>
              {/* fire different api depending if branch or not */}
              {/* {istype='branch'?(<div>Save Sales Order Branch (save_final_so_branch)</div>):(<div>Save Sales Order (save_final_so)</div>)} */}
              <ColorButton
                disabled={btnDisabled2}
                variant="contained"
                color="primary"
                onClick={() => {
                  save_final_so();
                }}
                classes={{
                  root: classes.root,
                  disabled: classes.disabled,
                }}
              >
                Save Sales Order
              </ColorButton>
            </div>
          </div>
        </Slide>
      ) : (
        <></>
      )}
		</div>

	);
};

export default SalesOrderInformation;
